export const es = {
    titulo: 'CACIN: Computer Aided Cataloguing of INcunabula',
    cancel: 'Cancelar',
    save: 'Guardar',
    editButton: 'Editar',
    accept: 'Aceptar',
    closeButton: 'Cerrar',
    filters: 'Filtros',
    loading: 'Cargando...',
    select: 'Seleccionar esta opción',
    
    NavBar : {
        menu: 'Menú',
        booksList: 'Lista de libros',
        office: 'Lista de imprentas',
        editDelete: 'Editar/Borrar libros',
        contactUs: 'Acerca de',

    },

    login : {
        log: 'Iniciar sesión',
        logout: 'Cerrar sesión',
        info: 'Inicia sesión para acceder al sistema',
        email: 'Dirección de correo electrónico',
        user: 'Usuario',
        password: 'Contraseña',
        error: 'Se requiere correo electrónico y contraseña',
        logError:'Error al iniciar sesión. Por favor, inténtelo de nuevo.',
        check: 'Comprobando credenciales...',
    },

contactUs: {
    title: "",
    welcome: "Este sitio web proporciona acceso a un catálogo de incunables con la capacidad de identificar de forma automática la tipografía utilizada en el texto impreso aplicando el método Proctor-Haebler que clasifica las tipografías en base a la altura de las líneas y la forma de las letras especiales. La identificación de la tipografía permite adscribir el incunable al taller que utilizó esa tipografía, así como ubicar espacial y temporalmente su impresión.",
    support: ").",
    supportLink: "(pedraza@unizar.es)",
    email: "El acceso al listado de incunables y oficinas de imprenta es libre. Para obtener acceso a las funciones de edición del catálogo se puede contactar con los profesores Manuel José Pedraza Gracia  ",
    emailLink: "(pedraza@unizar.es)",
    emailText: "y Javier Nogueras Iso ",
    emailLink2: "(jnog@unizar.es)",
    media: "Vídeo tutorial",
    mediaLink: "https://youtu.be/v49EJ7qHKJ4?si=3QF0zzW1TZ758qRa",
    medaiText: ">",
    repoText: "Repositorio GitHub",
    repoLink: "https://github.com/IAAA-Lab/CACIN",
    reference: "Referencias:",
    referenceText: "J. Lacasta, J. Nogueras-Iso, F.J. Zarazaga-Soria, M.J. Pedraza-Gracia (2022).  ",
    referenceLink: "Tracing the origins of incunabula through the automatic identification of fonts in digitised documents. ",
    referenceText2: "Multimedia Tools and Applications, 81:40977–40991."
  },
  home: {
    title: "",
    welcome: "Este sitio web proporciona acceso a un catálogo de incunables con la capacidad de identificar de forma automática la tipografía utilizada en el texto impreso aplicando el método Proctor-Haebler que clasifica las tipografías en base a la altura de las líneas y la forma de las letras especiales. La identificación de la tipografía permite adscribir el incunable al taller que utilizó esa tipografía, así como ubicar espacial y temporalmente su impresión.",
    support: ").",
    supportLink: "(pedraza@unizar.es)",
    email: "El acceso al listado de incunables y oficinas de imprenta es libre. Para obtener acceso a las funciones de edición del catálogo se puede contactar con los profesores Manuel José Pedraza Gracia  ",
    emailLink: "(pedraza@unizar.es)",
    emailText: "y Javier Nogueras Iso ",
    emailLink2: "(jnog@unizar.es)",
    media: "Vídeo tutorial",
    mediaLink: "https://youtu.be/v49EJ7qHKJ4?si=3QF0zzW1TZ758qRa",
    medaiText: ">",
    repoText: "Repositorio GitHub",
    repoLink: "https://github.com/IAAA-Lab/CACIN",
    reference: "Referencias:",
    referenceText: "J. Lacasta, J. Nogueras-Iso, F.J. Zarazaga-Soria, M.J. Pedraza-Gracia (2022).  ",
    referenceLink: "Tracing the origins of incunabula through the automatic identification of fonts in digitised documents. ",
    referenceText2: "Multimedia Tools and Applications, 81:40977–40991."
  },
  
  footer: {
    projectReference: "Este sitio web es parte del proyecto de I+D+i T59_23R financiado por el Gobierno de Aragón.",
    universityName: "Advanced Information Systems Laboratory (Grupo de Sistemas de Información Avanzados)",
  },
  
    booksTable: {
        addBook: 'Añadir libro',
        info: 'Información de los incunables',
        search: 'Buscar',
        placeholderTable: 'Buscar libros por título...',
        title: 'Título',
        id: 'ID',
        creator: 'Autor',
        fontType: 'Tipo de letra',
        publisher: 'Publicador',
        printingOffice: 'Imprenta',
        show: 'Número de resultados a mostrar: ',
    },

    filters: {
        title: 'Filtros',
        creator: 'Autor',
        publisher: 'Publicador',
        printingOffice: 'Imprenta',
        fontType: 'Tipo de letra',
        clear: 'Limpiar filtros',
        search: 'Buscar',
    },

    editDelete: {
        info: 'Edita o borra los incunables del sistema',
        actions: 'Acciones',
    },

    bookToDelete: {
        modalTitle: '¿Estás absolutamente seguro?',
        modalInfo: 'Esta acción no se puede deshacer. Esto eliminará permanentemente el incunable y eliminará los datos de nuestros servidores.',
        cancel: 'Cancelar',
        yes: 'Sí, borrar incunable',
    },

    edit: {
        title: 'Editar',
        info: 'Edita incunable ',
        bookId: 'ID',
        bookTitle: 'Título',
        bookCreator: 'Autor',
        bookPublisher: 'Publicador',
        bookPrintingOffice: 'Imprenta',
        bookFontType: 'Tipo de letra',
        file: 'Archivo',
        fileError: 'El formato del archivo debe ser .tiff o .tif',
        automaticRecognition: 'Reconocimiento automático',
        selectPrintingOffice: 'Selecciona una imprenta',
        selectFontType: 'Selecciona un tipo de letra',
        errorSelectFont: 'Primero debes seleccionar una imprenta',
        date: 'Año de publicación',
        location: 'Ubicación de publicación',
    },

    add: {
        title: 'Añadir incunable',
        info: 'Añade un nuevo incunable ',
        option: 'Opción ',
        bookTitle: 'Título',
        bookCreator: 'Autor',
        bookPublisher: 'Publicador',
        bookPrintingOffice: 'Imprenta',
        bookFontType: 'Tipo de letra',
    },

    modalAdd: {
        title: 'Nuevo incunable añadido',
        info: 'El incunable ha sido añadido correctamente',
        bookAddedMessage: 'El incunable ha sido añadido correctamente',
        bookId: 'ID',
    },

    modalImage: {
        title: 'Imagen del incunable',
        info: 'Añade una imagen del incunable ',
    },

    incunabula: {
        info: 'Información del incunable',
    },

    font : {
        title: 'Tipos de letra',
        info: 'Información del tipo de letra',
        id: 'ID',
        fontHeight: 'Tamaño de la letra',
        fontOffice: 'Imprenta',
        mShape: 'Forma de la letra M',
        fontImage: 'Imagen del tipo de letra',
    },

    newBookModal : {
        title: 'Nuevo incunable añadido',
        info: 'El incunable ha sido añadido correctamente',
    },

    printingOffice : {
        id: 'ID',
        title: 'Información de la imprenta',
        name: 'Nombre de la imprenta',
        alternativeName: 'Nombre alternativo',
        foundedYear: 'Año de fundación',
        closedYear: 'Año de cierre',
        location: 'Ubicación',
        placeholderTable: 'Buscar imprentas por nombre...',
        show: 'Número de resultados a mostrar: ',
        time: 'Época',
        search: 'Buscar imprentas',
    },


}
